export enum PaymentMethodName {
  Card = "card",
  Mobilepay = "mobilepay",
}
